import React from 'react';
import { useSelector } from 'react-redux';

import ChurgerIngredient from './ChurgerIngredient';
import bunsBackground from '../../assets/images/Churger/Backgrounds/bunsBackground.jpg';
import churgerBackground from '../../assets/images/Churger/Backgrounds/churgerBackground.jpg';

export default function Churger() {
	const ings = useSelector((state) => {
		return state.ingredients;
	});

	const category = useSelector((state) => {
		return state.category;
	});

	const meme = useSelector((state) => {
		return state.meme;
	});

	let transformedIngredients = Object.keys(ings)
		.map((igKey) => {
			return [...Array(ings[igKey])].map((_, i) => {
				return <ChurgerIngredient key={igKey + i} type={igKey} />;
			});
		})
		.reduce((arr, el) => {
			return arr.concat(el);
		}, []);

	const BGSet =
		category === 4
			? `center/ contain no-repeat url(${churgerBackground})`
			: `center/ contain no-repeat url(${bunsBackground})`;

	const inputsSet = category === 4 ? '' : 'none';

	return (
		<div className="ChurgerFrame" style={{ background: BGSet }}>
			<h1 id="name1" style={{ display: inputsSet }}>
				{meme.name1}{' '}
			</h1>
			<h2 id="name2" style={{ display: inputsSet }}>
				{meme.name2}{' '}
			</h2>
			<h3
				className="yellowCircleText"
				id="circ1"
				style={{ display: inputsSet }}
			>
				{meme.circ1}
			</h3>
			<h3
				className="yellowCircleText"
				id="circ2_1"
				style={{ display: inputsSet }}
			>
				{meme.circ2_1}
			</h3>
			<h1
				className="yellowCircleText"
				id="circ2_2"
				style={{ display: inputsSet }}
			>
				{meme.circ2_2}
			</h1>
			<h3
				className="yellowCircleText"
				id="circ3"
				style={{ display: inputsSet }}
			>
				{meme.circ3}
			</h3>
			<p className="legal" id="smolText" style={{ display: inputsSet }}>
				{meme.smolText}
			</p>
			<div className="Churger" id="Churger">
				{transformedIngredients}
			</div>
		</div>
	);
}
